import {FigmaElement} from "@/includes/fig-parser/models/base/figma-element";
import {FIG_PARSED_FIELD_TYPES} from "@/includes/fig-parser/constants";

export class FigmaImage extends FigmaElement {
  type = FIG_PARSED_FIELD_TYPES.IMAGE;
}
